import { useAtomValue } from 'jotai';
import { useCallback } from 'react';
import { currencyExchangeRateRTAtom } from '../../state';
import { Currency, CurrencyCross } from '../../types';

/**
 * Hook to retrieve real time currency exchange rates
 */
export const useCurrencyExchangeRateRT = () => {
  const currenciesExchangeRateRT = useAtomValue(currencyExchangeRateRTAtom);

  const getCurrencyExchangeRateRealTime = useCallback(
    (base: string, quote: string): number => {
      if (base === quote) {
        return 1;
      }
      const currencyCross: CurrencyCross = `${base as Currency}${quote as Currency}=`;
      const val = currenciesExchangeRateRT[currencyCross];
      if (!val || !val.isLoaded) {
        const reversedCurrencyCross: CurrencyCross = `${quote as Currency}${base as Currency}=`;
        const val = currenciesExchangeRateRT[reversedCurrencyCross];
        if (val && val.isLoaded) {
          return 1 / val.rateInHuf;
        }
        throw new Error(`Failed to get exchange rate for ${currencyCross}`);
      }
      return val.rateInHuf;
    },
    [currenciesExchangeRateRT],
  );

  return {
    currenciesExchangeRateRT: currenciesExchangeRateRT,
    getCurrencyExchangeRateRealTime,
  };
};
